import { render, staticRenderFns } from "./MiElementPanel.vue?vue&type=template&id=6d296c8d&"
import script from "./MiElementPanel.vue?vue&type=script&lang=ts&"
export * from "./MiElementPanel.vue?vue&type=script&lang=ts&"
import style0 from "@/components/MiElementPanel/mi-element-panel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports